<script setup>
import { Video, MessageSquare, TrendingUp, CalendarCheck } from 'lucide-vue-next'

defineProps({
  icon: {
    type: String,
    required: true
  },
  title: {
    type: String,
    required: true
  },
  description: {
    type: String,
    required: true
  },
  color: {
    type: String,
    default: 'blue'
  }
})

const icons = {
  video: Video,
  message: MessageSquare,
  chart: TrendingUp,
  calendar: CalendarCheck
}

const colorConfig = {
  blue: {
    bg: 'bg-blue-100',
    text: 'text-blue-600'
  },
  purple: {
    bg: 'bg-purple-100',
    text: 'text-purple-600'
  },
  green: {
    bg: 'bg-green-100',
    text: 'text-emerald-600'
  },
  orange: {
    bg: 'bg-orange-100',
    text: 'text-orange-600'
  }
}
</script>

<template>
  <div class="bg-white rounded-2xl p-6 md:p-8 shadow-lg hover:shadow-xl transition-all">
    <div :class="['w-14 h-14 rounded-xl flex items-center justify-center mb-4', colorConfig[color].bg]">
      <component :is="icons[icon]" :class="['w-7 h-7', colorConfig[color].text]" />
    </div>
    <h3 class="text-lg md:text-xl font-bold text-gray-900 mb-3">{{ title }}</h3>
    <p class="hidden md:block text-gray-600 leading-relaxed">{{ description }}</p>
  </div>
</template>
